module.exports = __webpack_public_path__ + "img/tr.dccebeb1.png";